import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import classnames from "classnames/bind";
import {
  MALE,
  FEMALE,
  LARGE_VIEWPORT,
  viewportPropType
} from "../../state/modules/layout";
import { focusPrimaryNavigationFor } from "../../globalEventHandler";
import withTranslation from "../translation";
import styles from "./FloorNavigation.css";

const cx = classnames.bind(styles);

class FloorNavigation extends PureComponent {
  handleFemaleClick = () => {
    this.setGender(FEMALE);
  };

  handleMaleClick = () => {
    this.setGender(MALE);
  };

  setGender(gender) {
    this.props.setGender(gender);
    focusPrimaryNavigationFor(gender);
  }

  isSelected(gender) {
    const { isFemale, isMale, viewport } = this.props;

    if (gender === MALE) {
      return isMale;
    }

    if (viewport === LARGE_VIEWPORT) {
      return isFemale;
    }

    return !isMale;
  }

  render() {
    const {
      formatTranslation,
      menStoreUrl,
      womenStoreUrl,
      viewport,
      viewable,
      isFemale
    } = this.props;

    const viewportProps =
      viewport === LARGE_VIEWPORT
        ? {
            menuTagType: "a",
            womenMenuActionProp: { href: womenStoreUrl },
            menMenuActionProp: { href: menStoreUrl },
            listRole: null,
            listItemRole: null,
            ariaLabelFemale: null,
            ariaLabelMale: null,
            ariaSelectedFemale: null,
            ariaSelectedMale: null,
            ariaCurrent: "page"
          }
        : {
            menuTagType: "button",
            womenMenuActionProp: { onClick: this.handleFemaleClick },
            menMenuActionProp: { onClick: this.handleMaleClick },
            listRole: "tablist",
            listItemRole: "tab",
            ariaLabelFemale: formatTranslation(
              "header_womens_products_aria_label"
            ),
            ariaLabelMale: formatTranslation("header_mens_products_aria_label"),
            ariaSelectedFemale: this.isSelected(FEMALE),
            ariaSelectedMale: this.isSelected(MALE),
            ariaCurrent: null
          };

    return (
      <ul
        className={cx(styles.container, {
          [styles.container__large]: viewable.includes(LARGE_VIEWPORT)
        })}
        data-testid="floornav"
        role={viewportProps.listRole}
      >
        <li>
          <viewportProps.menuTagType
            className={cx(styles.button, {
              [styles.selected]: this.isSelected(FEMALE)
            })}
            id="women-floor"
            data-testid="women-floor"
            {...viewportProps.womenMenuActionProp}
            aria-label={viewportProps.ariaLabelFemale}
            aria-selected={viewportProps.ariaSelectedFemale}
            role={viewportProps.listItemRole}
            aria-current={isFemale ? viewportProps.ariaCurrent : null}
          >
            {formatTranslation("header_women_floor")}
          </viewportProps.menuTagType>
        </li>
        <li>
          <viewportProps.menuTagType
            className={cx(styles.button, {
              [styles.selected]: this.isSelected(MALE)
            })}
            id="men-floor"
            data-testid="men-floor"
            {...viewportProps.menMenuActionProp}
            aria-label={viewportProps.ariaLabelMale}
            aria-selected={viewportProps.ariaSelectedMale}
            role={viewportProps.listItemRole}
            aria-current={isFemale ? null : viewportProps.ariaCurrent}
          >
            {formatTranslation("header_men_floor")}
          </viewportProps.menuTagType>
        </li>
      </ul>
    );
  }
}

FloorNavigation.propTypes = {
  formatTranslation: PropTypes.func.isRequired,
  isFemale: PropTypes.bool,
  isMale: PropTypes.bool,
  setGender: PropTypes.func.isRequired,
  viewport: viewportPropType,
  menStoreUrl: PropTypes.string.isRequired,
  womenStoreUrl: PropTypes.string.isRequired,
  viewable: PropTypes.arrayOf(viewportPropType)
};

FloorNavigation.defaultProps = {
  isFemale: false,
  isMale: false,
  viewable: []
};

export default withTranslation(FloorNavigation);
